import React from 'react';
import { PrivateAdvisoryLocationTemplate } from './PrivateAdvisoryLocationTemplate';

const Regina: React.FC = () => {
  return (
    <PrivateAdvisoryLocationTemplate
      city="Regina"
      province="Saskatchewan"
      provinceCode="SK"
      population="249,217"
      description={`As Saskatchewan's capital, Regina attracts ambitious leaders in government, business, and innovation. PCM's Private Advisory serves the Queen City's executives, entrepreneurs, and professionals with bespoke financial strategies that match the sophistication of your career. From C-suite insurance optimization to complex succession planning, your dedicated advisor delivers institutional expertise with exclusive, personalized service.`}
      majorIndustries={[
        'C-Suite Executives',
        'Government Leaders',
        'Tech Entrepreneurs',
        'Energy & Resource Leaders',
        'Healthcare Professionals',
        'Legal & Financial Executives'
      ]}
      nearbyAreas={[
        'White City',
        'Pilot Butte',
        'Lumsden Valley',
        'Greater Regina Area'
      ]}
      clientSuccess={[
        {
          title: 'Tech Founder Exit Strategy',
          description: 'A Regina tech entrepreneur needed to protect wealth during a major acquisition while minimizing tax exposure and ensuring family security.',
          outcome: 'Structured $8M in coverage optimizing capital gains exemption and creating generational wealth protection.'
        },
        {
          title: 'Executive Disability Architecture',
          description: 'A senior government executive required disability protection beyond standard group coverage to maintain lifestyle and protect retirement plans.',
          outcome: 'Designed $50K/month tax-free disability benefit with own-occupation definition and retirement contribution riders.'
        },
        {
          title: 'Professional Corporation Succession',
          description: 'Partners in a Regina professional firm needed buy-sell coverage and succession planning for seamless transition.',
          outcome: 'Implemented $15M buy-sell arrangement with tax-efficient funding saving partners $2M+ over traditional structures.'
        },
        {
          title: 'C-Suite Compensation Optimization',
          description: 'A public company executive needed to maximize after-tax value of compensation package including stock options and deferred comp.',
          outcome: 'Created insurance strategies increasing net estate value by $3.5M through coordinated planning.'
        }
      ]}
    />
  );
};

export default Regina;